const RankEnum = {
  VIP1: 0,
  VIP2: 1,
  VIP3: 2,
  VIP4: 3,
  VIP5: 4
}

export const getNextRank = (rank) => {
  const keys = Object.keys(RankEnum)
  const currentIndex = keys.indexOf(rank.toLowerCase())
  if (currentIndex !== -1 && currentIndex < keys.length - 1) {
    return keys[currentIndex + 1]
  }
  return ''
}